<template>
  <div class="meeting-sign">
    <div class="meeting-header">
      <i @click="
        $router.push({
          name: 'SignPage',
          params: { meetingId: submitModel.meetingId }
        })
      " class="arrow-left el-icon-arrow-left"></i>会议报名
    </div>
    <div class="meeting-body">
      <el-form :model="submitModel" ref="submitForm" class="submit-form">
        <el-form-item class="org-name" prop="orgName" :rules="{
          required: true,
          message: '单位名称不能为空',
          trigger: 'blur'
        }">
          <span>单位企业</span>
          <div class="org-select" @click="$router.push({ name: 'OrgNamePage', params: submitModel })">
            <el-input class="org-input" placeholder="请选择" :readonly="true"
              v-model.trim="submitModel.orgName"></el-input>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-form-item>
        <el-form-item prop="signerName" :rules="{
          required: true,
          message: '报名人姓名不能为空',
          trigger: 'blur'
        }">
          <el-input placeholder="请输入报名人姓名" maxlength="15" v-model.trim="submitModel.signerName"></el-input>
        </el-form-item>
        <el-form-item v-if="submitModel.hasSignerPositionName == 1" prop="positionName" :rules="{ required: true, message: '职务不能为空', trigger: 'blur' }">
          <el-input placeholder="请输入职务" maxlength="15" v-model.trim="submitModel.positionName"></el-input>
        </el-form-item>
        <el-form-item v-if="submitModel.hasOfficePhone == 1" prop="officePhone"
          :rules="{ required: true, message: '电话不能为空', trigger: 'blur' }">
          <el-input placeholder="请输入电话" @blur="mobileValid($event)" v-model.trim="submitModel.officePhone"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" :rules="{ required: true, message: '手机不能为空', trigger: 'blur' }">
          <el-input placeholder="请输入手机" @blur="phoneValid($event)" v-model.trim="submitModel.mobile"></el-input>
        </el-form-item>
        <el-form-item :rules="[
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]" prop="verCode">
          <el-input placeholder="请输入验证码" v-model="submitModel.verCode">
            <el-button type="text" class="code-btn" @click="sendCode" slot="suffix" :disabled="msgDisabled">{{ msgText
            }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item :rules="[
          { required: true, validator: this.validateLimitPeople, trigger: 'blur' }
        ]" prop="signCount">
          <el-input placeholder="请输入参会人数" v-model.trim="submitModel.signCount"></el-input>
        </el-form-item>
        <el-form-item prop="signerInfo" v-if="submitModel.hasSignerInfo == 1" :rules="[
          { required: true, message: '参会人信息不能为空', trigger: 'blur' }
        ]" style="margin-bottom:2px">
          <el-input maxlength="500" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" placeholder="请输入参会人信息"
            v-model="submitModel.signerInfo"></el-input>
        </el-form-item>
      </el-form>
      <li :class="{ 'meeting-decs': meetingDesc }" v-if="meetingDesc">
        <span class="submit-title">会议说明: </span>
        <span style="white-space:pre-line;line-height:1.15em;">{{meetingDesc ? meetingDesc : "————"}}</span>
      </li>
    </div>
    <div class="meeting-footer">
      <el-button class="submit-btn" type="primary" :disabled="submitDisabled" @click="submit">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "submit",
  data() {
    return {
      msgText: "获取验证码",
      msgDisabled: false,
      submitDisabled: false,
      msgTimes: 60,
      timer: null,
      meetingDesc:'',//会议说明
      submitModel: {
        hasSignerPositionName:'',
        hasSignerInfo:'',
        signCount: '',
        limitPeople: '',
        signerInfo: '',
        meetingId: "",
        orgName: "",
        signerName: "",
        positionName: "",
        officePhone: "",
        mobile: "",
        hasOfficePhone: "",
        verCode: "",
      }
    };
  },
  methods: {
    validateLimitPeople(rule, value, callback) {
      let reg = /^[+]{0,1}(\d+)$/g;
      if (value === '') {
        callback(new Error('请输入参会人数'));
      } else if (value == 0) {
        callback(new Error('参会人数不能为0'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入1到20的整数'));
      } else if (value > 20) {
        callback(new Error('参会人数不能超过20'));
      } else {
        callback();
      }
    },
    submit() {
      this.submitDisabled = true;
      this.$refs.submitForm.validate(valid => {
        if (valid) {
          this.$http
            .get(
              "/gdjx/pc/crm/meeting/sign/check?mobile=" +
              this.submitModel.mobile +
              "&meetingId=" +
              this.submitModel.meetingId
            )
            .then(res => {
              if (res.data && res.data.data) {
                if (res.data.data.hasSign) {
                  this.$createToast({



                    txt: "您已经报过名了",
                    type: "",
                    time: 2000
                  }).show();
                  this.submitDisabled = false;
                } else {
                  this.$http
                    .post("/gdjx/pc/crm/meeting/sign/commit", this.submitModel)
                    .then(res => {
                      if (res.data && res.data.success) {
                        this.$router.replace({ name: "ResultPage" });
                      } else {
                        this.$createToast({
                          txt: res.data.msg,
                          type: "",
                          time: 2000
                        }).show();
                      }
                      this.submitDisabled = false;
                    });
                }
              }
            });
        } else {
          this.submitDisabled = false;
        }
      });
    },
    phoneValid(e) {
      if (!/^1[3456789]\d{9}$/.test(e.target.value)) {
        this.$createToast({
          txt: "请输入正确手机号",
          type: "",
          time: 2000
        }).show();
      }
    },
    mobileValid(e) {
      if (!/^[0-9]+\d$/.test(e.target.value)) {
        this.$createToast({
          txt: "请输入数字",
          type: "",
          time: 2000
        }).show();
      }
    },
    sendCode() {
      if (!this.submitModel.mobile) {
        this.$createToast({
          txt: "手机不能为空",
          type: "",
          time: 2000
        }).show();
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.submitModel.mobile)) {
        this.$createToast({
          txt: "请输入正确的手机号码",
          type: "",
          time: 2000
        }).show();
        return;
      }
      // if (!this.submitModel.signCount) {
      //   this.$createToast({
      //     txt: "参会人数不能为空",
      //     type: "",
      //     time: 2000
      //   }).show();
      //   return;
      // }
      // if (this.submitModel.hasSignerInfo == 1 && !this.submitModel.signerInfo) {
      //   this.$createToast({
      //     txt: "参会人信息不能为空",
      //     type: "",
      //     time: 2000
      //   }).show();
      //   return;
      // }
      let params = {
        mobile: this.submitModel.mobile
      };
      this.msgDisabled = true;
      this.$http
        .post("/gdjx/pc/crm/meeting/sms/send", params)
        .then(res => {
          if (res.data && res.data.data) {
            this.$createToast({
              txt: res.data.data.msg,
              type: "",
              time: 2000
            }).show();
            this.msgTimeOut();
          }
        })
        .catch(e => {
          this.this.msgDisabled = false;
        });
    },
    msgTimeOut() {
      this.timer = setInterval(() => {
        this.msgTimes--;
        this.msgText = `验证码倒计时${this.msgTimes}`;
        if (this.msgTimes <= 0) {
          this.msgDisabled = false;
          this.msgTimes = 60;
          this.msgText = "获取验证码";
          clearInterval(this.timer);
        }
      }, 1000);
    },
    back() {
      this.$router.replace({
        path: "/sign",
        query: { meetingId: this.submitModel.meetingId }
      });
    }
  },
  created() {
    console.log('4444444444444444',this.$route.params);
    this.submitModel.meetingId = localStorage.getItem("meetingId");
    let orgName = this.$route.params.orgName;
    if (orgName) {
      this.submitModel.orgName = orgName;
    }
    this.submitModel.hasOfficePhone = this.$route.params.hasOfficePhone;
    this.submitModel.orgName = this.$route.params.orgName;
    this.submitModel.signerName = this.$route.params.signerName;
    this.submitModel.positionName = this.$route.params.positionName;
    this.submitModel.officePhone = this.$route.params.officePhone;
    this.submitModel.mobile = this.$route.params.mobile;
    this.submitModel.verCode = this.$route.params.verCode;
    this.submitModel.hasSignerPositionName = this.$route.params.hasSignerPositionName
    this.submitModel.hasSignerInfo = this.$route.params.hasSignerInfo
    this.meetingDesc = this.$route.params.meetingDesc
    console.log('4444444444444444',this.submitModel);
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.back, false); //false阻止默认事件
    }
  }
};
</script>
<style>
.meeting-sign {
  background-color: #f9f9f9;
  height: 100vh;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.meeting-header {
  background-color: #b6242b;
  color: #ffffff;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  position: relative;
}

.arrow-left {
  position: absolute;
  cursor: pointer;
  left: 10px;
  top: 25px;
  font-size: 44px;
  font-weight: bold;
}

.meeting-body {
  background-color: #ffffff;
  margin-top: 20px;
  width: 100%;
  overflow: auto;
  height: 88vh;
}

.submit-form {
  width: 100%;
}

.meeting-body .submit-form .el-form-item {
  border-bottom: 1px solid #dddee1;
  margin-left: 20px;
  border-bottom: 1px solid #dddddd;
}

.meeting-body .submit-form .el-input__inner {
  border-color: transparent;
  border: none;
}

.meeting-body .submit-form .el-form-item__error {
  padding-left: 15px;
}

.org-name .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 98%;
}

.org-select {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.el-input.is-disabled .el-input__inner {
  background-color: transparent;
  color: #333333;
}

.org-input input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.org-name span {
  width: 20%;
  text-align: right;
}

.org-name div {
  width: 80%;
}

.org-name .el-input__inner {
  text-align: right;
}

.meeting-footer {
  position: fixed;
  bottom: 5px;
  left: 30px;
  width: calc(100% - 60px);
}

.meeting-footer .submit-btn {
  width: 100%;
  padding: 20px 0;
}
.submit-title {
  width: 150px;
  font-size: 28px;
  margin-left: 20px;
}
.meeting-decs {
  align-items: flex-start !important;
  font-size: 28px;
  margin-bottom: 30px
}
.meeting-decs span:last-child {
  width: 85%;
  font-size: 28px;
  margin-bottom: 30px
}
</style>



// WEBPACK FOOTER //
// src/view/submitPage.vue